import React, { Dispatch, SetStateAction } from "react";
import Navigator from '../components/Navigation';
import { ArticleTextSection } from "../articleDetailPage/ArticleTextSection"
import { ProtectedArticleGroup } from "../articleDetailPage/ProtectedArticleGroup";
import { ArticleTitle } from "../articleDetailPage/ArticleTitle";
import { hashPasswordsFromEnv } from "../utils/passwordUtils";
import ArticleImageLayout from "../articleDetailPage/ArticleImageLayout";
import '../style.css';
import { Wavedivider } from "../components/Wavedivider";
import { CalloutLink } from "../components/CalloutLink";
import { useMetaTags } from '../utils/useMetaTags';
import ProtectedPage from "../components/ProtectedPage";
import street1 from '../image/articles/히로시마/거리1.webp';
import street2 from '../image/articles/히로시마/거리2.webp';
import turtle from '../image/articles/히로시마/거북이.webp';
import greentea1 from '../image/articles/히로시마/녹차1.webp';
import playground from '../image/articles/히로시마/놀이터.webp';
import proteinbar1 from '../image/articles/히로시마/단백질바1.webp';
import fish from '../image/articles/히로시마/붕어.webp';
import mountain1 from '../image/articles/히로시마/산거1.webp';
import mountain2 from '../image/articles/히로시마/산거2.webp';
import mountain3 from '../image/articles/히로시마/산거3.webp';
import shopping1 from '../image/articles/히로시마/쇼핑1.webp';
import shopping2 from '../image/articles/히로시마/쇼핑2.webp';
import shopping3 from '../image/articles/히로시마/쇼핑3.webp';
import shukkeien1 from '../image/articles/히로시마/슈케이엔1.webp';
import shukkeien2 from '../image/articles/히로시마/슈케이엔2.webp';
import shukkeien3 from '../image/articles/히로시마/슈케이엔3.webp';
import shukkeien4 from '../image/articles/히로시마/슈케이엔4.webp';
import shukkeien5 from '../image/articles/히로시마/슈케이엔5.webp';
import shukkeien6 from '../image/articles/히로시마/슈케이엔6.webp';
import restaurant1 from '../image/articles/히로시마/식당1.webp';
import restaurant2 from '../image/articles/히로시마/식당2.webp';
import restaurant3 from '../image/articles/히로시마/식당3.webp';
import nightview1 from '../image/articles/히로시마/야경1.webp';
import nightview2 from '../image/articles/히로시마/야경2.webp';
import nightview3 from '../image/articles/히로시마/야경3.webp';
import atomicdome1 from '../image/articles/히로시마/원폭돔1.webp';
import atomicdome3 from '../image/articles/히로시마/원폭돔3.webp';
import atomicdome4 from '../image/articles/히로시마/원폭돔4.webp';
import whiskey from '../image/articles/히로시마/위스키.webp';
import coffee1 from '../image/articles/히로시마/커피1.webp';
import coffee2 from '../image/articles/히로시마/커피2.webp';
import lunch2 from '../image/articles/히로시마/2일차점심.webp';
import lunch3 from '../image/articles/히로시마/3일차점심.webp';
import img3279 from '../image/articles/히로시마/IMG_3279.webp';
import img3351 from '../image/articles/히로시마/IMG_3351.webp';
import riverside1 from '../image/articles/히로시마/강변1.webp';
import riverside2 from '../image/articles/히로시마/강변2.webp';
import riverside3 from '../image/articles/히로시마/강변3.webp';
import greentea2b from '../image/articles/히로시마/녹차5.webp';
import greentea3 from '../image/articles/히로시마/녹차3.webp';
import greentea4 from '../image/articles/히로시마/녹차4.webp';
import depart1 from '../image/articles/히로시마/백화점1.webp';
import depart2 from '../image/articles/히로시마/백화점2.webp';
import depart4 from '../image/articles/히로시마/백화점4.webp';
import depart5 from '../image/articles/히로시마/백화점5.webp';
import walk1 from '../image/articles/히로시마/산책1.webp';
import walk2 from '../image/articles/히로시마/산책2.webp';
import walk3 from '../image/articles/히로시마/산책3.webp';
import walk4 from '../image/articles/히로시마/산책4.webp';
import walk5 from '../image/articles/히로시마/산책5.webp';
import walk7 from '../image/articles/히로시마/산책7.webp';
import church1 from '../image/articles/히로시마/성당1.webp';
import church2 from '../image/articles/히로시마/성당2.webp';
import church3 from '../image/articles/히로시마/성당3.webp';
import starbucks1 from '../image/articles/히로시마/스타벅스.webp';
import starbucks2 from '../image/articles/히로시마/스타벅스2.webp';
import home from '../image/articles/히로시마/집앞.webp';
import teahouse1 from '../image/articles/히로시마/찻집1.webp';
import rail1 from '../image/articles/히로시마/철길1.webp';
import rail2 from '../image/articles/히로시마/철길2.webp';
import sushi1 from '../image/articles/히로시마/초밥1.webp';
import sushi2 from '../image/articles/히로시마/초밥2.webp';
import sushi3 from '../image/articles/히로시마/초밥3.webp';
import sushi4 from '../image/articles/히로시마/초밥4.webp';
import day4_1 from '../image/articles/히로시마/넷째날1.webp';
import day4_2 from '../image/articles/히로시마/넷째날2.webp';
import miyajima1 from '../image/articles/히로시마/미야지마1.webp';
import miyajima2 from '../image/articles/히로시마/미야지마2.webp';
import miyajima3 from '../image/articles/히로시마/미야지마3.webp';
import deer1 from '../image/articles/히로시마/사슴1.webp';
import deer2 from '../image/articles/히로시마/사슴2.webp';
import deer3 from '../image/articles/히로시마/사슴3.webp';
import shrine from '../image/articles/히로시마/신사.webp';
import ferry1 from '../image/articles/히로시마/페리1.webp';
import ferry2 from '../image/articles/히로시마/페리2.webp';
import ferry3 from '../image/articles/히로시마/페리3.webp';
import ferry4 from '../image/articles/히로시마/페리4.webp';


const imagesStreet = [street1, street2, playground];
const imagesAtomicdome = [atomicdome1, atomicdome3, atomicdome4];
const imagesShukkeien = [shukkeien1, shukkeien2, shukkeien3];
const imagesShukkeien2 = [shukkeien4, shukkeien5, shukkeien6];
const imagesBoughtThings = [mountain1, mountain2, mountain3, ];
const imagesNightview = [nightview1, nightview2, nightview3];
const imagesRestaurant = [restaurant1, restaurant2, restaurant3];
const imagesShopping = [shopping1, shopping2, shopping3];
const imagesCafe = [coffee1, coffee2];
const imagesSnack = [whiskey, greentea1, proteinbar1, ];
const imagesAnimal = [turtle, fish, ];
const imagesRiverside = [riverside1, riverside2, riverside3];
const imagesGreenteaB = [greentea1, greentea2b, greentea3, greentea4];
const imagesDepart = [ depart2,  depart4, depart5, teahouse1];
const imagesWalkA = [walk1, walk2, walk3, walk4];
const imagesWalkB = [walk5, img3279, walk7];
const imagesChurch = [church1, church2, church3];
const imagesStarbucks = [starbucks1, starbucks2];
const imagesRail = [rail1, img3351,rail2, ];
const imagesSushi = [sushi1, sushi2, sushi3, sushi4];
const imagesLunch1 = [greentea3, lunch2, ];
const imagesLunch2 = [home, lunch3];
const imagesDay4 = [day4_1, day4_2];
const imagesMiyajima = [miyajima1, miyajima2, miyajima3];
const imagesDeer = [deer1, deer2, deer3];
const imagesShrine = [shrine];
const imagesFerry = [ferry1, ferry2, ferry4];


function Essay2606_hiroshima(props: {
    activeNav: number, 
    setActiveNav: Dispatch<SetStateAction<number>>,
  }) {
   
      
      const hashedPasswords = hashPasswordsFromEnv(
        process.env.REACT_APP_ESSAY2606_PASSWORDS
      );
    
      useMetaTags({
        title: '여행기록 - Lynkim',
        description: '히로시마 여행기록',
        image: '/ogimage.png',
      });
      
      return (
        <>
        {/* <ProtectedPage password={hashedPasswords} description="이 페이지의 비밀번호는 개인번호로 설정되어 있어요"> */}
        <Navigator activeNav={props.activeNav} setActiveNav={props.setActiveNav} />
        <div className='fadeIn '>
            <ArticleTitle
                title={'여행기록'}
                titleEn={'Travel Journal'}
                description={<div>히로시마에 두고온 것</div>}
                descriptionEn={'Things I brought back from Hiroshima'}
                category={'essay'}
                date={'2026.06.08.'}
                thumbnail={street1}
            />
        </div>
        <Wavedivider/>
        <div className='articleLayout'>

            <ArticleTextSection
                title='몰래 떠나기'
                titleEn='Slipping Away'
                marginBottom={true}
                // marginTop={true}
                description={<div>
                    어느 날 아침에 눈을 뜨자마자 어딘가로 훌쩍 떠나야겠다는 생각에 사로잡혀서 누운 채로 바로 히로시마로 떠나는 항공편을 예매했다. 정말 충동적인 계획이었다. 이 때 무슨 일이 생길지, 정말 갈 수 있을지 생각도 안 한 채 바로 예매를 하고, 떠나는 날이 되기까지도 혹시나 큰 이벤트가 생겨서 차질이 생기면 어쩌나 마음을 조마조마했던 것 같다. 
                    <br/><br/>혼자 여행하는 걸 그렇게 좋아하지 않으면서 왜 이렇게 막 떠나고 싶었나 하면 기억이 나지 않는다. 그때는 딱 히로시마로 가야만 할 것 같았다. 며칠을 일본 여행 브이로그를 보면서 여행하는 느낌으로 대리만족을 했는데, 가만히 똑같은 공간에 머무르지 않고 훌쩍 떠나고 싶은 생각이 들었다.  
                    <br/>무엇인가로부터 벗어나고 싶었고, 혹은 도망치고 싶었던 것 같기도 하다. 시끄러움으로부터 벗어나고 싶었던 것 같다. 조용한 곳으로 도망치는 느낌이었다. 요즘은 무엇인가 하려고만 하면, 내가 그래도 되나? 염치없어, 나 따위가, 자격없어 등등 이런 말들이 머릿속에서 나를 자꾸 위축되게 만든다. 그래도 한편으로 나를 위한 시간을 온전히 가져도 돼. 편안해도 돼 하는 생각도 들어서, 그래서 머릿속에서 자꾸 시끄럽게 싸워댄다. 수없이 머릿속에서 내가 시끄럽게 떠드는 것 같은 느낌이었다. 
                    <br/><br/>그래서 여행 짐을 챙기며 이번 여행에는 다른 사람 하나도 생각하지 말고, 오로지 내가 하고싶은 대로 편안하게 여행하고 오자 하는 생각으로, 화장품도 다 놓고, 옷도 대충 몇 벌만 챙겼다. 읽고 싶었던 책 “낭만적 연애와 그 후의 일상” 한 권과 노트북을 챙겨 매고, 아무런 계획도 없이 훌쩍 떠나왔다. 
                    <br/>여행을 계획도 딱 두 명 빼고 아무에게도 알리지 않았다. 최근에 나를 참 많이 신경 써 주는 사람들이 있는데, 그 두 명에게만 연락이 없어도 걱정하지 말라고 알려주고 떠났다. 그래서 회사 사람들도 내가 지금 일본에 있는지 모른다. 왠지 몰래 도망온 것 같아서 땡땡이 치는 학생이 된 것 같은 느낌도 든다. 
                    </div>} />


            
            <ArticleTextSection
                title='첫째날'
                titleEn='First Day'
                marginBottom={true}
                marginTop={true}
                description={<div>
                  비행기 시간보다 한참 일찍이 출발해서 공항에 도착하니 굉장히 여유로웠다. 시간이 한참 남아서 이 시간을 어떻게 보내나 했는데, 생각보다 이것저것 구경하고 커피 한잔 마시며 여행지에서 할 것들을 찾다 보니 시간이 금방 지나갔다. 
                  <br/>그리고 이번에는 홀린듯이 면세점에서 위스키를 샀다. 내가 면세점에서 위스키를 사는 날이 오다니! 
                  <br/><br/><b>보모어 19년 피노누아 캐스크 피니시</b>
                  <br/>원래 면세점에서 이렇게 큰 돈을 주고 위스키를 사는 것을 한 번도 생각을 해 본 적이 없는데, 지나가다가 좋아하는 보모어 위스키가 있는 것을 발견하고 시음을 해 볼 수 있다는 말에 홀린 듯 들어가서 시음을 했다. 그런데 정말이지 19년산을 먹어보고는 너무 맛있어서 깜짝 놀랐다. 보모어 19년은 얇은 껍질의 적포도주인 피노누아 와인 배럴에서 피니시를 한 위스키라고 한다. 그래서 그런지 은은하게 스모키하면서 달달한 피노누아 향이 느껴졌다. 보모어는 피트한 느낌에 정말 좋아하는 위스키인데, 또 거기에 내가 가장 좋아하는 피노누아 향을 입혀서 오묘하게 부드러우면서 달큰한 느낌이 너무 좋았다.   
                  <br/>좋은 날 몇 번이고 다시 먹고 싶다는 생각을 해서, 지인에게 내가 이걸 사도 될까요? 몇 번을 물어보고는 (사실 답정너이긴 했다) 10만원 아끼는거지 하고 단번에 구매했다. 
                    </div>} />
            
            <ArticleImageLayout images={imagesSnack} /> 
           
            <ArticleTextSection
              marginBottom={true}
              marginTop={true}
              description ={<div>
                비행기에서 내리자마자 숙소에 짐을 풀어놓으니 오후 4시였다. 먹은게 없다보니 가는 길이 너무 힘들어서 편의점에 들러서 가장 좋아하는 브랜드의 일본 녹차와 연어 삼각김밥, 그리고 처음 보는 단백질바를 샀다. 오자마자 녹차를 마셔야지 했는데, 정말 일본 녹차만의 진하고 씁쓸한 맛은 몇번을 먹어도 너무 맛있다. 일본에 와서 녹차를 마시면 일본여행이 시작되는 느낌이다. 
                <br/><br/>삼각김밥은 연어 맛을 하나 사 봤는데, 밥만 많고 연어가 별로 없어서 연어 있는 부분만 먹고 남겼다. 사실 연어 있는 부분은 정말 맛있긴 했다. 그리고 집으로 가는 버스를 기다리면서 밀크티 맛 단백질바를 먹어 봤는데, 정말 한 입 먹고 너무너무 맛있어서 자리에서 순삭해버렸다. 다음에 갈 때 또 사 먹고 싶다. 그런데 이때 너무 배가고파서 그랬던 건지, 다음번에 다시 똑같은 것을 사먹었는데 너무 달기만해서 몇 입 먹기 어려울 정도였다. 
                <br/><br/>숙소는 아기자기하고 마음에 들었다. 창문으로 강과 작은 집이 보이는데 너무 예쁘고, 일본의 아기자기한 감성이 그대로 느껴졌다. 밖에는 작은 공원과 낡은 그네, 미끄럼틀이 있는데 울창한 나무 아래 조그마한 놀이기구들이 있는 게 왠지 아기자기 예쁘면서도 버려진 작은 집안 뜰을 보는 느낌이어서 쓸쓸함도 느껴졌다. 
              </div>}    />   
                   
            <ArticleImageLayout images={imagesStreet} />
            
            <ArticleTextSection
              marginBottom={true}
              marginTop={true}
              description ={<div>
                숙소는 도심에서 조금 거리가 있는 강가에 위치해 있었는데, 히로시마의 관광지로 유명한 슛케이엔 공원까지 3분 정도 밖에 안걸릴 정도로 아주 가까웠다. 슛케이엔은 숙소와 가까우니 언제든지 갈 수 있겠거니 나중에 시간 날 때 한번 들러봐야겠다고 생각했는데, 막상 도착하고 보니 시간이 좀 늦어서, 도심 구경보다는 가까운 슛케이엔이나 먼저 돌아봐야겠다 생각했다. 그런데 여행 첫날인 오늘 오길 정말 잘했다. 
<br/><br/>들어서는 입구에서 공원을 지키는 경비 아저씨가 사진을 찍는 나를 보고는 혹시 본인이 사진에 나올까봐 호다닥 문 뒤로 숨었다. 그리고는 얼마뒤 빼꼼 얼굴을 내밀어 사진을 다찍었는지 살펴보았는데, 너무 감사하면서 귀엽고 웃겼다.
<br/><br/>슛케이엔 공원 한 바퀴를 도는 내내 돈을 내고 들어온 게 아깝지 않을 만큼 평화로움이 커서, 그 자체로 행복하게 만들어주었다. 한 바퀴를 도는 것뿐이었는데 가는 곳곳 모든 곳이 다 다르게 느껴지는 공간이었다. 작은 길을 따라 걸으며 나무 판자로 만든 다리를 건너가고, 돌 다리를 뛰어넘고, 꽃밭을 걷고, 오솔길을 걸었다. 물길의 다리를 건널 때는 다리가 작고 좁아 한 명씩만 건널 수 있었는데, 그래서 반대편에서 오는 사람과 눈 인사를 하며 서로 양보하는 느낌도 재밌었다. 
               
               </div>}    />   
            
            <ArticleImageLayout images={imagesShukkeien} />
            <ArticleImageLayout images={imagesShukkeien2} />
            <ArticleTextSection
              marginBottom={true}
              marginTop={true}
              description ={<div>
               슛케이엔 공원 한 바퀴를 도는 내내 돈을 내고 들어온 게 아깝지 않을 만큼 평화로움이 커서, 그 자체로 행복하게 만들어주었다. 한 바퀴를 도는 것뿐이었는데 가는 곳곳 모든 곳이 다 다르게 느껴지는 공간이었다. 작은 길을 따라 걸으며 나무 판자로 만든 다리를 건너가고, 돌 다리를 뛰어넘고, 꽃밭을 걷고, 오솔길을 걸었다. 물길의 다리를 건널 때는 다리가 작고 좁아 한 명씩만 건널 수 있었는데, 그래서 반대편에서 오는 사람과 눈 인사를 하며 서로 양보하는 느낌도 재밌었다. 
                </div>}    />  
            <ArticleImageLayout images={imagesAnimal} />
            

            <ArticleImageLayout images={imagesAtomicdome} />
            <ArticleImageLayout images={imagesCafe} />
            <ArticleImageLayout images={imagesShopping} />
            <ArticleImageLayout images={imagesRestaurant} />
            <ArticleImageLayout images={imagesNightview} />
            <ArticleImageLayout images={imagesBoughtThings} />


            <ArticleTextSection
                title='둘째날'
                titleEn='Second Day'
                marginBottom={true}
                marginTop={true}
                description={<div>
                  혼자일 때 느끼는 외로움
                    </div>} />
                    <ArticleImageLayout images={imagesWalkB} />
                    <ArticleImageLayout images={imagesWalkA} />
                    <ArticleImageLayout images={imagesLunch1} />
                    <ArticleImageLayout images={imagesStarbucks} />
            

            <ArticleTextSection
                title='셋째날'
                titleEn='Third Day'
                marginBottom={true}
                marginTop={true}
                description={<div>
                  혼자일 때 느끼는 외로움
                    </div>} />

            
            
            
            
            <ArticleImageLayout images={imagesLunch2} />
            <ArticleImageLayout images={imagesChurch} />
            <ArticleImageLayout images={imagesRiverside} />
            
            <ArticleImageLayout images={imagesDepart} />
            
            
            <ArticleImageLayout images={imagesSushi} />
            
            
            <ArticleImageLayout images={imagesRail} />

            <ArticleTextSection
                title='넷째날'
                titleEn='Fourth Day'
                marginBottom={true}
                marginTop={true}
                description={<div>
                  분명 일본 날씨 예보는 흐리고 비가 올 것이라고 했는데, 막상 일어나보니 해가 쨍쨍하니 햇살이 눈부실 정도였다. 오늘 배를 타고 미야지마 섬으로 가려고 하는 날이다. 비가 와도 충분히 기분좋게 다녀올 수 있을거라고 생각했는데, 날이 더이상 좋을 수 없이 맑아서 더 기분이 좋아졌다. 
                  <br/>페리를 타기 위해 미야지마구치로 가는 열차를 타러 걸어가는데, 나오자마자 이유없이 '오늘은 왠지 정말 행복한 날이 될 것 같아' 라는 막연한 생각에 들떴다.
                  <br/>들뜬 것도 잠시, 열차를 타고 가는 내내 잠이 쏟아지고 에너지가 나지 않아서, 열차에서 내리자마자 비타민과 단백질바를 하나 사먹었다. 일본에는 편의점 비타민 음료가 또 유명하다고 하는데, 무려 3000mg 짜리라니. 한 병 마시고나니 왠지 모르게 몸 안에서 뭔가 열기가 나는 느낌이었다. 

                    </div>} />
            <ArticleImageLayout images={imagesDay4} />
            
            <ArticleImageLayout images={imagesFerry} />
            
            <ArticleImageLayout images={imagesShrine} />
            <ArticleImageLayout images={imagesDeer} />
            <ArticleImageLayout images={imagesMiyajima} />
            <ArticleTextSection
                subTitle='일본 녹차'
                subTitleEn='Japanese green tea'
                marginBottom={true}
                marginTop={true}
                description={<div>
                  일본은 여러가지 녹차를 맛보러가는 것이라고 해도 과언이 아니다. 항상 일본에 도착하면 편의점 녹차를 사마시는데, 이번에는 좀더 다양한 녹차를 사봤다. 
                  일본은 편의점에서 파는 녹차가 정말 많은데, 마셔본 것 중에 두 번째 녹차가 제일 맛있었다. 
                    </div>} />
            <ArticleImageLayout images={imagesGreenteaB} />

            <ArticleTextSection
                title='히로시마에 두고온 것'
                titleEn='Things I brought back from Hiroshima'
                marginBottom={true}
                marginTop={true}
                description={<div>
                  혼자일 때 느끼는 외로움
                    </div>} />
            
            
            
            


        </div>
        {/* </ProtectedPage> */}
        </>
      )
  }

export default Essay2606_hiroshima;